import { takeLatest, all } from 'redux-saga/effects'
import API from 'Services/Api'

/* ------------- Types ------------- */

import { StartupTypes } from 'Redux/StartupRedux'
import { AuthTypes } from 'Redux/AuthRedux'
import { UserTypes } from 'Redux/UserRedux'
import { TeamTypes } from 'Redux/TeamRedux'
import { ProjectTypes } from 'Redux/ProjectRedux'
import { CollaboratorTypes } from 'Redux/CollaboratorRedux'
import { VideoTypes } from 'Redux/VideoRedux'
import { VideoIntegrationTypes } from 'Redux/VideoIntegrationRedux'
import { CommentTypes } from 'Redux/CommentRedux'
import { PlanTypes } from 'Redux/PlanRedux'
import { LinkTypes } from 'Redux/LinkRedux'
import { ActivityTypes } from 'Redux/ActivityRedux'

/* ------------- Sagas ------------- */

import { onStartup } from './StartupSagas'
import {
  onSignupRequest, onForgotPasswordRequest, onResetPasswordRequest,
  onLoginRequest, onGoogleLoginRequest, onLogoutRequest,
  onUserConfirmationSuccess, onProfileUpdateRequest, onProfileRequest
} from './AuthSagas'

import {
  onUsersRequest, onUserShowRequest, onUpdateUserRequest, onDeleteUsersRequest,
  onCreateUserRequest
} from './UserSagas'

import {
  onTeamsRequest
} from './TeamSagas'

import {
  onVideoJwPushRequest
} from './VideoIntegrationSagas'

import {
  onProjectsRequest, onCreateProjectRequest, onUpdateProjectRequest,
  onDeleteProjectRequest
} from './ProjectSagas'

import {
  onCollaboratorsRequest, onAddCollaboratorRequest,
  onRemoveCollaboratorRequest
} from './CollaboratorSagas'

import {
  onProjectVideosRequest, onVideoVersionsRequest,
  onVideosCreateRequest,
  onVideosUpdateRequest, onVideosDeleteRequest, onVideosUnversionRequest
} from './VideoSagas'

import {
  onVideoCommentsRequest, onCreateCommentRequest,
  onSearchCommentsRequest, onDeleteCommentsRequest
} from './CommentSagas'

import {
  onPlansRequest,
  onPlansUpdateRequest
} from './PlanSagas'

import {
  onLinksRequest, onCreateLinkRequest
} from './LinkSagas'

import {
  onActivitiesRequest
} from './ActivitySagas'

/* ------------- API ------------- */

// The API we use is only used from Sagas, so we create it here and pass along
// to the sagas which need it.
const api = API.create()

/* ------------- Connect Types To Sagas ------------- */

export default function * root () {
  yield all([
    // ------ Startup Sagas -----------
    takeLatest(StartupTypes.STARTUP, onStartup, api),

    // ------ Auth Sagas -----------
    takeLatest(AuthTypes.SIGNUP_REQUEST, onSignupRequest, api),
    takeLatest(AuthTypes.FORGOT_PASSWORD_REQUEST, onForgotPasswordRequest, api),
    takeLatest(AuthTypes.RESET_PASSWORD_REQUEST, onResetPasswordRequest, api),
    takeLatest(AuthTypes.LOGIN_REQUEST, onLoginRequest, api),
    takeLatest(AuthTypes.GOOGLE_LOGIN_REQUEST, onGoogleLoginRequest, api),
    takeLatest(AuthTypes.LOGOUT_REQUEST, onLogoutRequest, api),
    takeLatest(
      AuthTypes.PROFILE_UPDATE_REQUEST, onProfileUpdateRequest, api
    ),
    takeLatest(
      AuthTypes.PROFILE_REQUEST, onProfileRequest, api
    ),
    takeLatest(
      AuthTypes.USER_CONFIRMATION_SUCCESS, onUserConfirmationSuccess, api),

    // ------ Auth Sagas -----------
    takeLatest(UserTypes.USERS_LIST_REQUEST, onUsersRequest, api),
    takeLatest(UserTypes.USERS_SHOW_REQUEST, onUserShowRequest, api),
    takeLatest(UserTypes.USERS_CREATE_REQUEST, onCreateUserRequest, api),
    takeLatest(UserTypes.USERS_UPDATE_REQUEST, onUpdateUserRequest, api),
    takeLatest(UserTypes.USERS_DELETE_REQUEST, onDeleteUsersRequest, api),

    // ------ Team Sagas -----------
    takeLatest(TeamTypes.TEAMS_LIST_REQUEST, onTeamsRequest, api),

    // ------ Project Sagas -----------
    takeLatest(ProjectTypes.PROJECTS_LIST_REQUEST, onProjectsRequest, api),
    takeLatest(
      ProjectTypes.PROJECTS_CREATE_REQUEST, onCreateProjectRequest, api),
    takeLatest(
      ProjectTypes.PROJECTS_UPDATE_REQUEST, onUpdateProjectRequest, api),
    takeLatest(
      ProjectTypes.PROJECTS_DELETE_REQUEST, onDeleteProjectRequest, api),

    // ------ Collaborator Sagas -----------
    takeLatest(
      CollaboratorTypes.COLLABORATORS_LIST_REQUEST,
      onCollaboratorsRequest, api),
    takeLatest(
      CollaboratorTypes.COLLABORATORS_ADD_REQUEST,
      onAddCollaboratorRequest, api),
    takeLatest(
      CollaboratorTypes.COLLABORATORS_REMOVE_REQUEST,
      onRemoveCollaboratorRequest, api),

    // ------ Video Sagas -----------
    takeLatest(VideoTypes.VIDEOS_LIST_REQUEST, onProjectVideosRequest, api),
    takeLatest(
      VideoTypes.VIDEOS_CREATE_REQUEST, onVideosCreateRequest, api
    ),
    takeLatest(
      VideoTypes.VIDEOS_UPDATE_REQUEST, onVideosUpdateRequest, api
    ),
    takeLatest(
      VideoTypes.VIDEOS_DELETE_REQUEST, onVideosDeleteRequest, api
    ),
    takeLatest(
      VideoTypes.VIDEOS_UNVERSION_REQUEST, onVideosUnversionRequest, api
    ),
    takeLatest(
      VideoTypes.VIDEOS_VERSIONS_REQUEST, onVideoVersionsRequest, api),

    // ------ Video Integration Sagas --------
    takeLatest(
      VideoIntegrationTypes.VIDEO_JW_PUSH_REQUEST, onVideoJwPushRequest, api),

    // ------ Comment Sagas -----------
    takeLatest(CommentTypes.COMMENTS_LIST_REQUEST, onVideoCommentsRequest, api),
    takeLatest(
      CommentTypes.COMMENTS_CREATE_REQUEST, onCreateCommentRequest, api),
    takeLatest(
      CommentTypes.COMMENTS_SEARCH_REQUEST, onSearchCommentsRequest, api),
    takeLatest(
      CommentTypes.COMMENTS_DELETE_REQUEST, onDeleteCommentsRequest, api),

    // ------ Plan Sagas -----------
    takeLatest(PlanTypes.PLANS_LIST_REQUEST, onPlansRequest, api),
    takeLatest(PlanTypes.PLANS_UPDATE_REQUEST, onPlansUpdateRequest, api),

    // ------ Link Sagas -----------
    takeLatest(LinkTypes.LINKS_LIST_REQUEST, onLinksRequest, api),
    takeLatest(LinkTypes.LINKS_CREATE_REQUEST, onCreateLinkRequest, api),

    // ------ Activity Sagas -----------
    takeLatest(ActivityTypes.ACTIVITIES_LIST_REQUEST, onActivitiesRequest, api),
  ])
}



// WEBPACK FOOTER //
// ./src/Sagas/index.js